(function($) {
		$(document).ready(function() {
		
  		$('body').on('click', '.video', function(e){
			e.preventDefault();
		
			let url = $(this).attr('href');
		
			if($(this).attr('data-youtube-id')){
				url = 'https://www.youtube.com/embed/'+$(this).attr('data-youtube-id')+'?autoplay=1'
			}else if($(this).attr('data-vimeo-id')){
				url = 'https://player.vimeo.com/video/'+$(this).attr('data-vimeo-id');
			}
			
			console.log('url', url);
			
			console.log('$.fancybox', $.fancybox);
		
			if(url){
				$.fancybox.open({
				  src  : url,
				  type : 'iframe',
				  opts : {
					afterShow : function( instance, current ) {
					  //console.info( 'done!' );
					}
				  }
				});
			}
			
			
		});
		
		
		if($(".blog-content-inner").length > 0){
		
			$(".blog-content-inner").fitVids();
			
			setTimeout(function(){
				$(".blog-content-inner").fitVids();
			}, 750);
		
		}
		
	});
	
})(jQuery);